import { Link } from "react-router-dom";
import { Card } from "../../components/ui/Card";
import { useAdminWorkspaces } from "../../features/superadmin/api";

export default function SuperadminWorkspacesPage() {
  const { data, isLoading, isError, error } = useAdminWorkspaces();

  return (
    <Card title="Workspaces">
      {isLoading ? (
        <div className="skeleton-rows">Loading…</div>
      ) : isError ? (
        <div className="form-error">{(error as Error).message}</div>
      ) : (
        <div className="table-wrap">
          <table className="data-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Slug</th>
                <th>Whatrite</th>
                <th>Whatmail</th>
                <th>Forms API key</th>
              </tr>
            </thead>
            <tbody>
              {(data?.workspaces ?? []).map((w) => (
                <tr key={w.id}>
                  <td><Link to={`/superadmin/${w.id}`} className="row-link">{w.name}</Link></td>
                  <td><code>{w.slug}</code></td>
                  <td><span className="badge">{w.whatriteEnabled ? "on" : "off"}</span></td>
                  <td><span className="badge">{w.whatmailEnabled ? "on" : "off"}</span></td>
                  <td>{w.formsApiKey ? <code className="muted">{w.formsApiKey.slice(0, 8)}…</code> : "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Card>
  );
}
